import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import apiUrl from "../libs/baseUrl";
import { notifyToast } from "../libs/generalFunctions";
import { errorHandeling } from "../errorHandeling";

/**
 * Submit an employee objection against a finalized disciplinary decision.
 * Multipart: `reason` (required) + `evidence[]` (0..5 files). We must NOT set
 * Content-Type manually — axios adds the multipart boundary for FormData.
 *
 * The backend enforces every rule (finalized + approved row + own + one-per-employee
 * + within the 7-day window); any failure comes back as a 422 whose Arabic message
 * `errorHandeling` surfaces as a toast.
 */
export default function useSubmitObjection() {
  const token = useSelector((state) => state.user.token);

  const [loading, setLoading] = useState(false);

  const submitObjection = async (caseEmployeeId, { reason, files = [] } = {}) => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("reason", reason ?? "");
      files.forEach((file) => formData.append("evidence[]", file));

      const res = await axios.post(
        `${apiUrl}/disciplinary-case-employees/${caseEmployeeId}/objections`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (res.data?.status === "success") {
        notifyToast("SUCCESS", "تم تقديم الاعتراض");
        return { success: true, data: res.data.data };
      }

      notifyToast("ERROR", "فشل تقديم الاعتراض");
      return { success: false };
    } catch (err) {
      notifyToast("ERROR", errorHandeling(err));
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { submitObjection, loading };
}
